const fieldset = document.getElementById("subscription-fieldset")
function setSellingPlan() {
    const subscription = document.getElementById("subscription");
    const select = document.getElementById("selling_plan_id");
    const quantity = document.querySelector('[name="quantity"]')
    if (subscription.checked) {
        subscription.value = select.value;
        quantity.value = 3;
        quantity.min = 3;
        let currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('selling_plan', select.value);

        // Use history.pushState to update URL without page reload
        history.pushState({}, '', currentUrl.href);

    }
    else {
        subscription.value = "";
        quantity.value = 1;
        quantity.min = 1;
        let currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('selling_plan');
        history.pushState({}, '', currentUrl.href);

    }
    console.log(subscription)
}
setSellingPlan()
fieldset.addEventListener("change", setSellingPlan)
